import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FaLogoComponent } from '@shared/fa-logo/fa-logo.component';
import { CustomerReviewsRatingBarComponent } from '../customer-reviews-rating-bar/customer-reviews-rating-bar.component';

@Component({
    selector: 'app-customer-reviews-container',
    imports: [
        CustomerReviewsRatingBarComponent,
        FontAwesomeModule,
        FaLogoComponent,
    ],
    templateUrl: './customer-reviews-container.component.html',
})
export class CustomerReviewsContainerComponent {
    faStar = faStar;
}
